import { DomainTargeting } from '@openx/types/targeting/domains.ts';
import {
  CustomBlockingRulesOptions,
  type PublisherInventoryRule,
  PublisherInventoryRuleActions,
  type PublisherInventoryRuleOptions,
} from '@openx/types/targeting/inventoryAndContent.ts';

export const preparePublisherInventoryRulesPayload = (
  currentState: PublisherInventoryRule[],
  publisherInventoryRuleOptions: PublisherInventoryRuleOptions,
  payload: string[]
): PublisherInventoryRule[] => {
  const ruleToAdd: PublisherInventoryRule = {
    action: PublisherInventoryRuleActions.BLOCK,
    blockingRuleOption: publisherInventoryRuleOptions.blockingRuleOption,
    bundle_id: [],
    domain: [],
    publisher_id: publisherInventoryRuleOptions.publisherID,
    subdomain: [],
  };

  const rulesMap = new Map<string, PublisherInventoryRule>();

  currentState.forEach(rule => {
    const key = `${rule.publisher_id}_${rule.blockingRuleOption}`;
    rulesMap.set(key, rule);
  });

  const ruleToAddKey = `${ruleToAdd.publisher_id}_${ruleToAdd.blockingRuleOption}`;
  const ruleToUpdate = rulesMap.get(ruleToAddKey);

  if (publisherInventoryRuleOptions.blockingRuleOption === CustomBlockingRulesOptions.BUNDLE_ID) {
    ruleToAdd.bundle_id = payload;

    if (ruleToUpdate) {
      rulesMap.set(ruleToAddKey, {
        ...ruleToAdd,
        bundle_id: [...ruleToUpdate.bundle_id, ...ruleToAdd.bundle_id],
      });

      return [...rulesMap.values()];
    }
  }

  if (publisherInventoryRuleOptions.blockingRuleOption === CustomBlockingRulesOptions.DOMAIN) {
    if (publisherInventoryRuleOptions.domainTargetingOption === DomainTargeting.ALL_VARIATIONS) {
      ruleToAdd.subdomain = payload;
    } else {
      ruleToAdd.domain = payload;
    }

    if (ruleToUpdate) {
      const domainTargetingKey = ruleToAdd.domain.length ? 'domain' : 'subdomain';

      rulesMap.set(ruleToAddKey, {
        ...ruleToAdd,
        [domainTargetingKey]: [...ruleToUpdate.domain, ...ruleToUpdate.subdomain, ...ruleToAdd[domainTargetingKey]],
      });

      return [...rulesMap.values()];
    }
  }

  return [...currentState, ruleToAdd];
};
